var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoldSearch = function SvgBoldSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m43 38.84-6.34-6a18.5 18.5 0 0 1-4.28 4l6.52 6.2a2.979 2.979 0 1 0 4-4.36z",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.28 4a18 18 0 1 0 0 36 18 18 0 0 0 0-36m0 30.72A12.7 12.7 0 1 1 34.98 22a12.68 12.68 0 0 1-12.7 12.72"
  })));
};
export default SvgBoldSearch;